module.exports = __webpack_public_path__ + "img/settings.0a4dfd98.svg";